export const DEFAULT_PORTAL_USER_MATCHMAKING = {
  id: 0,
  country: '',
  expansion_states: [],
  expansion_countries: [],
  country_selected: null,
  expansion_states_selected: null,
  expansion_countries_selected: null,
  domestic_expansion_strategy: '',
  international_expansion_strategy: '',
  next_franchise_in: '',
  franchisor_start_amount: '',
  investment_amount: '',
  entry_fee: '0.00',
  fair_country: '',
  license_fee: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
}

export const GERMANY_STATES = [
  {
    "id": 3006,
    "country_id": 82,
    "name": "Baden-Württemberg",
    "code": "BW"
  },
  {
    "id": 3009,
    "country_id": 82,
    "name": "Bayern",
    "code": "BY"
  },
  {
    "id": 3010,
    "country_id": 82,
    "name": "Berlin",
    "code": "BE"
  },
  {
    "id": 3013,
    "country_id": 82,
    "name": "Brandenburg",
    "code": "BB"
  },
  {
    "id": 3014,
    "country_id": 82,
    "name": "Bremen",
    "code": "HB"
  },
  {
    "id": 3016,
    "country_id": 82,
    "name": "Hamburg",
    "code": "HH"
  },
  {
    "id": 3018,
    "country_id": 82,
    "name": "Hessen",
    "code": "HE"
  },
  {
    "id": 3008,
    "country_id": 82,
    "name": "Niedersachsen",
    "code": "NI"
  },
  {
    "id": 3007,
    "country_id": 82,
    "name": "Mecklenburg-Vorpommern",
    "code": "MV"
  },
  {
    "id": 3017,
    "country_id": 82,
    "name": "Nordrhein-Westfalen",
    "code": "NW"
  },
  {
    "id": 3019,
    "country_id": 82,
    "name": "Rheinland-Pfalz",
    "code": "RP"
  },
  {
    "id": 3020,
    "country_id": 82,
    "name": "Saarland",
    "code": "SL"
  },
  {
    "id": 3021,
    "country_id": 82,
    "name": "Sachsen",
    "code": "SN"
  },
  {
    "id": 3011,
    "country_id": 82,
    "name": "Sachsen-Anhalt",
    "code": "ST"
  },
  {
    "id": 3005,
    "country_id": 82,
    "name": "Schleswig-Holstein",
    "code": "SH"
  },
  {
    "id": 3015,
    "country_id": 82,
    "name": "Thüringen",
    "code": "TH"
  }
]

export const COUNTRY_LANGUAGES = {
  en: 'GBR',
  de: 'DEU',
  it: 'ITA',
  nl: 'NLD'
}